"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var epsilon_ajax_request_1 = require("../../utils/epsilon-ajax-request");
var EpsilonColorSchemesPreviewer = /** @class */ (function () {
    /**
     * Constructor
     */
    function EpsilonColorSchemesPreviewer() {
        var self = this;
        wp.customize.preview.bind('update-inline-color-schemes-css', function (object) {
            var data = {
                action: [object.class, object.action],
                nonce: EpsilonWPUrls.ajax_nonce,
                args: object.data,
                id: object.id
            }, Ajax;
            Ajax = new epsilon_ajax_request_1.EpsilonAjaxRequest(data);
            Ajax.request();
            jQuery(Ajax).on('epsilon-received-success', function (e) {
                var sufix = object.action + object.id, style = jQuery('#epsilon-stylesheet-' + sufix);
                if (!style.length) {
                    style = jQuery('body').
                        append('<style type="text/css" id="epsilon-stylesheet-' + sufix + '" />').
                        find('#epsilon-stylesheet-' + sufix);
                }
                if (style.html() !== Ajax.result.css) {
                    style.html(Ajax.result.css);
                }
            });
        });
    }
    return EpsilonColorSchemesPreviewer;
}());
exports.EpsilonColorSchemesPreviewer = EpsilonColorSchemesPreviewer;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/previewer/color-schemes/color-schemes.ts
// module id = 32
// module chunks = 1